import styled, { css, FlattenInterpolation, ThemedStyledProps } from 'styled-components'

import { CheckIcon } from 'primsell-shared-layer/assets/icons'
import { baseTheme } from 'primsell-shared-layer/styles/theme'

import { CheckboxVariantT, CheckboxColorT } from './checkbox.types'

const colorsConfig: Record<CheckboxColorT, string> = {
  black: '#3C3C43',
  violet: baseTheme.colors.violet,
}

export const Input = styled.input`
  display: none;
`

interface ICheckVariantCssProps {
  color: CheckboxColorT
}

const primaryVariantCheckPathCss = css<ICheckVariantCssProps>`
  stroke: ${baseTheme.colors.white};
`

const secondaryVariantCheckPathCss = css<ICheckVariantCssProps>`
  stroke: ${({ color }) => colorsConfig[color]};
`

const checkVariantStylesConfig: Record<
  CheckboxVariantT,
  FlattenInterpolation<ThemedStyledProps<ICheckVariantCssProps, unknown>>
> = {
  primary: primaryVariantCheckPathCss,
  secondary: secondaryVariantCheckPathCss,
}

export const Check = styled(CheckIcon)`
  flex-shrink: 0;
`

interface IContainerVariantCssProps {
  color: CheckboxColorT
}

const primaryVariantContainerCss = css<IContainerVariantCssProps>`
  width: 18px;
  height: 18px;
  border: 1.6px solid ${({ color }) => colorsConfig[color]};

  &:has(${Input}:checked) {
    background-color: ${({ color }) => colorsConfig[color]};
  }
`

const secondaryVariantContainerCss = css<IContainerVariantCssProps>`
  width: 12px;
  height: inherit;
`

const containerVariantStylesConfig: Record<
  CheckboxVariantT,
  FlattenInterpolation<ThemedStyledProps<IContainerVariantCssProps, unknown>>
> = {
  primary: primaryVariantContainerCss,
  secondary: secondaryVariantContainerCss,
}

interface IContainerProps {
  variant: CheckboxVariantT
  color: CheckboxColorT
}

export const Container = styled.label<IContainerProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 2px;
  cursor: pointer;

  ${({ variant }) => containerVariantStylesConfig[variant]};

  & svg path {
    ${({ variant }) => checkVariantStylesConfig[variant]};
  }
`
